$(document).ready(function() {
  var taste_profile_icon = $('<a/>', { class:'taste-profile-icon', target: '_self', html: '<i class="fas fa-question-circle"></i>' });
  var taste_profile_toggler = $('.taste-profile:contains("Taste Profile")');
  taste_profile_icon.click(function() {
    taste_profile_toggler.click(function() {
      return false;
    });
    window.location = '../pages/profile-guide';
  });
  taste_profile_icon.insertBefore(taste_profile_toggler.find('span'));
});

addCartJS = (evt) => {
  // Retrieve quantity
  var $this = $(evt);
  var vid = $this.attr('data-vid');
  var qty = parseInt($('#collection-quantity-'+vid).val());

  // Cart js add item, success callback, error callback
  CartJS.addItem(vid, qty, {}, {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
      console.log("Added succesfully !", textStatus);
      // Display a success toast, with a title
      toastr.success('Successfully Added to cart');
      setTimeout(function(){
        location.reload();
      },1000);
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
      // Display an error toast, with a title
      toastr.error(jqXHR.responseJSON.description)
    }
  });
}

$('.collection-qty').on('click', function(){
  var $this = $(this);
  var vid = $this.attr('data-vid');

  var qty = parseInt($('#collection-quantity-'+vid).val());

  if($this.hasClass('product-plus')){
    qty += 1;
  }
  else{
    if (qty != 1){ qty -=1 }
  }
  $('#collection-quantity-'+vid).val(qty);

});
